import { Factory, trait } from 'miragejs';
import { formatISO, subSeconds } from 'date-fns';
import { faker } from '@faker-js/faker';

const DEVICE_TYPES = ['iPad5,4', 'iPad6,8', 'iPad5,1', 'iPad2,7', 'iPad4,2'];

export default Factory.extend({
  printerStatus: 'connected',
  connected: true,
  isConnected: true,
  appVersion: '11.2.6',
  currentIpadAppVersion: '11.2.6',

  name: () => faker.lorem.words(),
  wifiNetwork: () => faker.lorem.words(),
  deviceType: () => faker.helpers.arrayElement(DEVICE_TYPES),

  asRecentlySeen: trait({
    lastHeartbeatAt: formatISO(subSeconds(new Date(), 10)),
  }),
});
